<h2 mat-dialog-title class="flex items-center gap-2 m-0 px-4 py-3 border-b">
  <mat-icon>person</mat-icon>
  {{ title }}
</h2>

<mat-dialog-content class="!p-0">
  <div class="flex flex-col gap-3 p-4 h-[600px]">
    <!-- Header con búsqueda y contador -->
    <div class="flex items-center justify-between gap-4">
      <mat-form-field appearance="outline" class="flex-1 !mb-0">
        <mat-label>Buscar usuario</mat-label>
        <input matInput [formControl]="searchControl" placeholder="Username, nombre, email...">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      @if (service.selectedCount() > 0) {
        <div class="flex items-center gap-2">
          <button
            type="button"
            (click)="showSelectedPreview = !showSelectedPreview"
            class="px-3 py-1.5 bg-blue-100 text-blue-700 rounded-full text-sm font-medium hover:bg-blue-200 transition-colors flex items-center gap-1">
            {{ service.selectedCount() }} seleccionados
            <mat-icon class="!text-[18px] !w-[18px] !h-[18px]">{{ showSelectedPreview ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="service.clearSelection$.next()" matTooltip="Limpiar selección">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
      }
    </div>

    <!-- Preview de seleccionados (colapsible, horizontal scroll) -->
    @if (service.selectedCount() > 0 && showSelectedPreview) {
      <div class="flex gap-2 p-2 bg-gray-50 rounded-lg border overflow-x-auto">
        @for (user of service.selectedUsers(); track user._id) {
          <span class="inline-flex items-center gap-1 px-2 py-1 bg-white border rounded text-sm whitespace-nowrap shrink-0">
            <mat-icon class="!w-4 !h-4 !text-[16px]">person</mat-icon>
            {{ user.user_login_username || user.user_login_first_name }}
            <button mat-icon-button class="!w-5 !h-5" (click)="onToggleUser(user)">
              <mat-icon class="!text-[14px]">close</mat-icon>
            </button>
          </span>
        }
      </div>
    }

    <!-- Error -->
    @if (service.error()) {
      <div class="flex flex-col items-center gap-2 p-4 text-red-500">
        <mat-icon>error_outline</mat-icon>
        <span>Error al cargar usuarios</span>
        <button mat-stroked-button color="primary" (click)="service.retry$.next()">
          <mat-icon>refresh</mat-icon> Reintentar
        </button>
      </div>
    }

    <!-- SmartGrid -->
    @if (!service.error()) {
      <div class="flex-1 min-h-[300px]">
        <app-smart-grid
          [data]="service.users()"
          [columnDefs]="columnDefs"
          [config]="gridConfig"
          [loading]="service.isLoading()"
          [totalRecords]="service.total()"
          [pageIndex]="service.page() - 1"
          [initialSelectedRows]="service.selectedUsers()"
          (selectionChanged)="onSelectionChanged($event)"
          (pageChanged)="onPageChange($event)">
        </app-smart-grid>
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-end gap-2 px-4 py-3 border-t">
  <button mat-button (click)="onCancel()">
    Cancelar
  </button>
  <button mat-flat-button color="primary" (click)="onConfirm()">
    <mat-icon>check</mat-icon>
    Aceptar ({{ service.selectedCount() }})
  </button>
</mat-dialog-actions>
